<span id="cancelcasemanmodal" dat-bs-toggle="modal" data-bs-target="#ClosecasemanModal"></span>
  <div class="modal fade primarymodal modalbackgrod" id="ClosecasemanModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
      <div class="modal-dialog create-update-zip" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title font-header" id="exampleModalLabel" >Close</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                  </button>
              </div>
              <div class="modal-body">
                 You want to close without save?
              </div>
              <div class="modal-footer">
              <button type="button" class="btn blue-btn btn-sm" >Yes</button>
              <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
              </div>
          </div>
      </div>
  </div>  
  <span id="openModal" data-bs-target="#importmodalopen" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="importmodalopen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
             <h5 class="modal-title font-header" id="exampleModalLabel" >Budget Import </h5>
              <button type="button" class="btn-close"  data-bs-dismiss="modal" aria-label="Close" (click)="closeFun()">
                <span aria-hidden="true"></span>
              </button>
          </div>
            <div class="modal-body">
              <form >
                <div class="row">
                  <div class="col-lg-3">
                    <label>Client Name<sup class="super-script">*</sup>
                    </label>
                  </div>
                  <div class="col-lg-8">
                      <ng-select class="w-100"
                      >
                    </ng-select></div>
                </div>
              
                <div class="row mt-1" >
                    <div class="col-lg-3">
                        <label>Budget</label>
                    </div>
                    <div class="col-lg-8">
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" name="filename"
                              >
                            <label class="custom-file-label" for="customFile">Choose file</label>
                            <label for="customFile"></label>
                        </div>
                    </div>
                </div>  
              </form> 
            </div>
          <div class="modal-footer">
            <button class="btn blue-btn btn-sm"  
            [disabled]="!CaseForm.valid">Import </button>
          <button type="button" class="btn blue-btn btn-sm"  dat-bs-dismiss="modal"(click)="closeFun()">Close</button>
          </div>
        </div>
      </div>
  </div> 